import { AvailablePrices } from "src/features/menudata";

export function hasMemberPrices(...availablePrices: (AvailablePrices | undefined)[]) {
    return availablePrices.some((price) => price?.memberPrice !== undefined);
}
